export const ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
}

export const MENU_BORDER_WIDTH = 1
